import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewScreen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15 12H9M12 9V15",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.5 5H6.75C5.7835 5 5 5.7835 5 6.75V8.5M15.5 5H17.25C18.2165 5 19 5.7835 19 6.75V8.5M19 15.5V17.25C19 18.2165 18.2165 19 17.25 19H15.5M8.5 19H6.75C5.7835 19 5 18.2165 5 17.25V15.5",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgNewScreen;
